export default "__VITE_ASSET__CAzj1o80__"